(() => {
  class RejectMailOrderCompleteVisitController {
    constructor($rootScope, $scope, $timeout, $interval, toastr, $state, ngDialog) {
      'ngInject';

      Object.assign(this, {
        $scope,
        $rootScope,
        $timeout,
        $interval,
        toastr,
        $state,
        ngDialog,
        message: $scope.ngDialogData && $scope.ngDialogData.message ? $scope.ngDialogData.message : null,
      });
    }

    close() {
      this.$scope.closeThisDialog(false);
    }

    chargeWithoutPayment() {
      this.$scope.closeThisDialog(true);
    }
  }

  RejectMailOrderCompleteVisitController.$inject = [
    '$rootScope',
    '$scope',
    '$timeout',
    '$interval',
    'toastr',
    '$state',
    'ngDialog',
  ];
  angular.module('pims').controller('RejectMailOrderCompleteVisitController', RejectMailOrderCompleteVisitController);
})();
